var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_grid _grid-cols-2 _grid-cols-3--m _gap-2",
      attrs: { "data-qa": "recently-viewed-projects:Skeleton" },
    },
    _vm._l(3, function (n) {
      return _c(
        "skeleton-wrapper",
        { key: n },
        [
          _c("skeleton-image", {
            staticClass: "_rounded--common _bxsh--base",
            attrs: { loading: "lazy" },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }